import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { KeeniconComponent } from '../keenicon/keenicon.component';

@Component({
  selector: 'ui-link',
  imports: [KeeniconComponent],
  templateUrl: './link.component.html',
  styleUrl: './link.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkComponent {
  icon = input('');
  text = input('');
  iconClass = input('fs-3 text-primary');
}
